'use strict';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Normalizes the GraphQL connect options by providing default values for missing properties.
 *
 * @template P - The type of the payload.
 * @param {GqlConnectOptions<P>} options - The GraphQL connect options.
 * @param {string} [options.endpoint] - The GraphQL endpoint. @default process.env.GRAPHQL_ENDPOINT || ''.
 * @param {string} [options.token] - The GraphQL token. @default process.env.GRAPHQL_TOKEN.
 * @returns {NormalisedGqlConnectOptions<P>} - The normalized GraphQL connect options.
 */ function normaliseGqlConnectOptions(options) {
    return _extends({}, options, {
        endpoint: options.endpoint || process.env.GRAPHQL_ENDPOINT || '',
        token: options.token || process.env.GRAPHQL_TOKEN
    });
}

module.exports = normaliseGqlConnectOptions;
